// Aka Media Visibility. "include_in" is the name of the media column in the DB.
const IncludeIn = {
  BOTH: "both",
  GALLERY: "gallery",
  NEITHER: "neither",
};

export default IncludeIn;
